import React from 'react';
import { AutoComplete } from 'antd';
import FloatingLabelInput from './FloatingLabelInput';

interface FloatingLabelAutoCompleteProps {
  label: string;
  value?: string;
  onChange?: (value: string) => void;
  /** Suggestion strings only (e.g. brand or model names) -- seed data, never a closed list. */
  options: string[];
  disabled?: boolean;
  style?: React.CSSProperties;
}

/**
 * FloatingLabelInput (see that component) with an AutoComplete suggestion
 * dropdown layered on top -- passing it as AutoComplete's customizeInput
 * child (antd's documented "Customize Input Element" pattern) keeps the
 * exact same pill/floating-label chrome as every other text field in these
 * forms, no separate styling needed. Purely a typing aid: whatever the host
 * types is accepted as-is (no validation against `options`, nothing here
 * ever blocks submit) -- this is seed data, not a closed catalog.
 */
const FloatingLabelAutoComplete: React.FC<FloatingLabelAutoCompleteProps> = ({ label, value, onChange, options, disabled, style }) => {
  const acOptions = options.map((option) => ({ value: option }));

  return (
    <AutoComplete
      value={value}
      options={acOptions}
      onChange={onChange}
      disabled={disabled}
      style={style}
      filterOption={(inputValue, option) =>
        !!option?.value && String(option.value).toLowerCase().includes(inputValue.trim().toLowerCase())
      }
      classNames={{ popup: { root: 'heavyDutyMachinery-location-popup' } }}
    >
      <FloatingLabelInput label={label} disabled={disabled} />
    </AutoComplete>
  );
};

export default FloatingLabelAutoComplete;
